/* Selected pediatric research: approved 700ms counters, once on entry. */
(function(){
  'use strict';
  if(window.__fizzyPediatricResearch)return;
  window.__fizzyPediatricResearch=true;
  var preference=window.matchMedia('(prefers-reduced-motion: reduce)');
  var active=new Set(),counted=new WeakSet();
  function quiet(){return preference.matches||document.hidden;}
  function countUp(el) {
    if (counted.has(el)) return;
    counted.add(el);
    var original = el.textContent.trim();
    var match = original.match(/^([^\d]*)(\d[\d,]*(?:\.\d+)?)(.*)$/);
    if (!match || quiet()) return;
    var target = Number(match[2].replace(/,/g, ''));
    if (!target) return;
    var decimals = (match[2].split('.')[1] || '').length;
    var formatted = new Intl.NumberFormat('en-US', {
      minimumFractionDigits: decimals, maximumFractionDigits: decimals,
      useGrouping: match[2].indexOf(',') !== -1
    });
    var oldWidth = el.style.minWidth;
    el.style.minWidth = el.getBoundingClientRect().width + 'px';
    var accessible = document.createElement('span');
    accessible.className = 'pediatric-count-accessible';
    accessible.textContent = original;
    var visual = document.createElement('span');
    visual.setAttribute('aria-hidden', 'true');
    visual.textContent = original;
    el.replaceChildren(accessible, visual);
    var frame = 0, start = null;
    var delay = Math.min(140, Math.max(0, Number(el.dataset.countDelay) || 0));
    function finish() {
      cancelAnimationFrame(frame);
      el.textContent = original;
      el.style.minWidth = oldWidth;
      active.delete(finish);
    }
    active.add(finish);
    function tick(time) {
      if (!el.isConnected || quiet()) { finish(); return; }
      if (start === null) start = time;
      var progress = Math.max(0, Math.min(1, (time - start - delay) / 700));
      var value = target * (1 - Math.pow(1 - progress, 3));
      visual.textContent = match[1] + formatted.format(value) + match[3];
      if (progress < 1) frame = requestAnimationFrame(tick); else finish();
    }
    frame = requestAnimationFrame(tick);
  }

  var observer='IntersectionObserver' in window?new IntersectionObserver(function(entries){entries.forEach(function(entry){if(entry.isIntersecting){observer.unobserve(entry.target);countUp(entry.target);}});},{threshold:.15}):null;
  function init(){document.querySelectorAll('[data-pediatric-count]').forEach(function(el){if(el.dataset.countBound)return;el.dataset.countBound='true';if(observer&&!quiet())observer.observe(el);else counted.add(el);});}
  function finish(){if(quiet())active.forEach(function(end){end();});}
  preference.addEventListener('change',finish);
  document.addEventListener('visibilitychange',finish);
  document.addEventListener('shopify:section:load',init);
  init();
})();
